<template>
  <div v-if="isOpen">
    <slot :options="options" :open-modal="openModal" :close-modal="closeModal" :current-modal="currentModal" />
  </div>
</template>

<script>
import { defineComponent, inject, computed } from 'vue'

import useModal from '@/hooks/useModal'

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true
    }
  },

  setup (props) {
    const appState = inject('appState')
    const isOpen = computed(() => appState.modal?.name === props.name)
    const options = computed(() => (appState.modal?.options || {}))

    const { openModal, closeModal, currentModal } = useModal()

    return {
      isOpen,
      options,
      openModal,
      closeModal,
      currentModal
    }
  }
})
</script>
